import { motion } from "framer-motion";
import { IMAGES, MANIFESTO, KATIE_STORY } from "@/data/content";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 } }),
};

export const About = () => (
  <section id="about" className="bg-cream py-24 md:py-32">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        {/* Sticky image */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <motion.p
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
              className="text-xs uppercase tracking-[0.28em] text-blush mb-6"
            >
              (Meet Katie)
            </motion.p>
            <div className="overflow-hidden">
              <motion.img
                initial={{ scale: 1.2, opacity: 0 }} whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true }} transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
                src={IMAGES.about} alt="Katie, founder of Klean With Katie" className="w-full h-[560px] object-cover object-top"
              />
            </div>
            <p className="mt-4 font-serif italic text-xl text-cocoa">The face behind Klean with Katie 🤍</p>
          </div>
        </div>

        {/* Story + manifesto */}
        <div className="lg:col-span-7">
          <motion.h2
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="font-serif font-light text-espresso text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mb-10 max-w-xl"
          >
            From care work to a <span className="italic text-blush">little dream</span> of my own.
          </motion.h2>

          <div className="space-y-6 max-w-xl">
            {KATIE_STORY.paragraphs.map((p, i) => (
              <motion.p
                key={i} custom={i} variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}
                className="text-base md:text-lg font-light text-muted-foreground leading-relaxed"
              >
                {p}
              </motion.p>
            ))}
          </div>

          <motion.blockquote
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="my-12 border-l-2 border-blush pl-6 md:pl-8"
          >
            <p className="font-serif italic font-light text-espresso text-2xl md:text-4xl leading-snug">
              "{KATIE_STORY.pullquote}"
            </p>
            <footer className="mt-3 text-xs uppercase tracking-[0.22em] text-cocoa">— My mum, the day it all began</footer>
          </motion.blockquote>

          <div className="grid sm:grid-cols-3 gap-8 border-t border-border pt-10">
            {MANIFESTO.map((m, i) => (
              <motion.div key={m.num} custom={i} variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>
                <span className="font-serif text-4xl font-light text-blush leading-none">{m.num}</span>
                <h3 className="font-serif text-xl md:text-2xl text-espresso mt-3 mb-2">{m.title}</h3>
                <p className="text-sm font-light text-muted-foreground leading-relaxed">{m.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
